import { Box, Button, Flex, Spacer, useBoolean, useToast } from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import Form from './Form';
import { BiPlus, BiSave } from 'react-icons/bi';
import { RiCloseCircleLine } from 'react-icons/ri';
import { createForm, deleteForm, getForms, updateForm } from '../Services';
import { FeatureContext } from '../../../Context';
import List from './List';
import { Loader } from '../Loader';
import { Theme } from '../Theme';


const FormBuilder = () => {

  const [loader, setLoader] = useBoolean();
  const toast = useToast();

  const onCreateForm = (value) => {
    setLoader.on();
    createForm(value)
      .then(_ =>
        toast({
          position: 'bottom-right',
          status: 'success',
          isClosable: true,
          title: 'Form are correctly created'
        }))
      .catch(error => {
        toast({
          position: 'bottom-right',
          status: 'error',
          isClosable: true,
          title: 'We are sorry, an error occured when saving settings, ' + error.message
        })
      })
      .finally(_ => { setLoader.off(); loadForms(); state.onCloseForm() });
  }

  const onUpdateForm = (value) => {
    setLoader.on();
    updateForm(value)
      .then(response => {
        toast({
          position: 'bottom-right',
          status: 'success',
          isClosable: true,
          title: 'Form are correctly updated'
        })
      })
      .catch(error => {
        toast({
          position: 'bottom-right',
          status: 'error',
          isClosable: true,
          title: 'We are sorry, an error occured when updating settings, ' + error.message
        })
      })
      .finally(_ => { setLoader.off(); loadForms(); state.onCloseForm() });
  }

  const onDeleteForm = (value) => {
    setLoader.on();
    deleteForm(value.id)
      .then(response => {
        toast({
          position: 'bottom-right',
          status: 'success',
          isClosable: true,
          title: 'Form are correctly deleted'
        })
      })
      .catch(error => {
        toast({
          position: 'bottom-right',
          status: 'error',
          isClosable: true,
          title: 'We are sorry, an error occured when deleting settings, ' + error.message
        })
      })
      .finally(_ => { setLoader.off(); loadForms(); state.onCloseForm() });

  }

  const loadForms = () => {
    getForms()
      .then((results) => {
        results.map(value => {
          let schema = JSON.parse(value.frmschema);
          schema = { ...schema, title: value.title, description: value.description }
          value.frmschema = JSON.stringify(schema);
          return value;
        })
        state.setForms(results)
      })
  }

  useEffect(() => {
    loadForms();
  }, []);

  const [state, setState] = useState({
    isEdit: false,
    isNew: false,
    forms: [],
    form: {},
    setForms: (value) => setState(prevState => ({ ...prevState, forms: value })),
    setForm: (value) => setState(prevState => ({ ...prevState, form: value })),
    updateForm: (value) => setState(prevState => ({ ...prevState, form: value })),
    onNewForm: _ => setState(prevState => ({ ...prevState, form: '', isNew: true, isEdit: false })),
    onEditForm: (value) => setState(prevState => ({ ...prevState, form: value, isNew: false, isEdit: true })),
    onCloseForm: _ => setState(prevState => ({ ...prevState, form: '', isNew: false, isEdit: false })),
    onDeleteForm: onDeleteForm
  });


  return <FeatureContext.Provider value={state}>
    <Flex background={'#e9e9e9'} direction={'row'} p={2} alignItems={'flex-end'} justifyContent={'flex-end'}>
      {(!state.isEdit && !state.isNew) ?
        <Button disabled={loader} onClick={state.onNewForm} size={'sm'} colorScheme='blue'>
          <BiPlus size={20} /><Spacer w={'10px'} />New Form
        </Button> : null}
      {(state.isNew) ?
        <Button disabled={loader} onClick={() => onCreateForm(state.form)} size={'sm'} colorScheme='blue' mr={2}>
          <BiSave size={20} /><Spacer w={'10px'} />Create Form
        </Button> : null}
      {(state.isEdit) ?
        <Button disabled={loader} onClick={() => onUpdateForm(state.form)} size={'sm'} colorScheme='blue' mr={2}>
          <BiSave size={20} /><Spacer w={'10px'} />Update Form
        </Button> : null}
      {(state.isNew || state.isEdit) ?
        <Button disabled={loader} onClick={state.onCloseForm} size={'sm'} colorScheme='red'>
          <RiCloseCircleLine size={20} /><Spacer w={'10px'} />Close
        </Button> : null}

    </Flex>
    {(!state.isEdit && !state.isNew) ?
      <Box p={3} style={Theme.Container}><List /></Box> :
      <Box p={3}><Form /></Box>}
    {(loader) ? <Loader /> : null}
  </FeatureContext.Provider>
};

export default FormBuilder